
import {
    defineComponent,
    ref
} from "vue";
import cigoLayer from "./layer";

export default defineComponent({
    name: "CigoLayerConfirm",
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        const ok = () => {
            //Tips_Flag 探秘Promise的用法：答疑antdesign的点击不同结果事件
            new Promise((resolve, reject) => {
                    ctx.emit("notify", "ok", resolve, reject);
                })
                .then(() => {
                    ctx.emit("close");
                })
                .catch(() => {
                    console.log("hold on");
                });
        };

        const cancel = () => {
            new Promise((resolve, reject) => {
                    ctx.emit("notify", "cancel", resolve, reject);
                })
                .then(() => {
                    ctx.emit("close");
                })
                .catch(() => {
                    console.log("hold on");
                });
        };

        return {
            ok,
            cancel
        };
    }
});
